<template>
    <div class="marker-deliverer" :style="style" @click="openModal">
        <h6>{{name}}</h6>
    </div>
</template>

<script>
export default {
    name: 'ht-deliverer-marker',
    mounted() {

    },
    props: ['color', 'deliverer'],
    methods: {
        openModal: function() {
            this.$events.fire('open-deliverer-modal', this.deliverer)
        }
    },
    computed: {
        style: function() {
            return 'background-image: url('+this.deliverer.image+'); border: 2px solid ' +this.color+';';
        },
        name: function() {
            let split = this.deliverer.fullname.split(" ");
            return split[0];
        }
    }
}
</script>

<style lang="scss">
    .marker-deliverer {
        width: 40px;
        height: 40px;
        border: solid 2px #00420D;
        border-radius: 50%;
        background-color: white;
        background-position: center;
        background-size: contain;
        h6 {
            margin-left: 0px;
            padding-top: 38px;
        }
    }
</style>
